import { createSlice } from '@reduxjs/toolkit';
import { getUserRole } from '../../../helpers';
const userRole = getUserRole(localStorage.getItem('token'));
const initialState = {
    token: localStorage.getItem('token'),
    refreshToken: localStorage.getItem('refreshToken'),
    isAuthenticated: !!localStorage.getItem('token') && !!userRole,
    role: userRole,
};
const adminAuthSlice = createSlice({
    name: 'adminAuth',
    initialState,
    reducers: {
        loginSuccess(state, action) {
            state.token = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
            state.isAuthenticated = true;
            state.role = getUserRole(action.payload.token);
            localStorage.setItem('token', action.payload.token);
            localStorage.setItem('refreshToken', action.payload.refreshToken);
        },
        logout(state) {
            state.token = null;
            state.refreshToken = null;
            state.isAuthenticated = false;
            state.role = null;
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
        },
    },
    selectors: {
        selectIsAuthenticated: (state) => state.isAuthenticated,
        selectToken: (state) => state.token,
        selectRefreshToken: (state) => state.refreshToken,
        selectRole: (state) => state.role,
    },
});
export const { loginSuccess, logout } = adminAuthSlice.actions;
export const { selectIsAuthenticated, selectToken, selectRefreshToken, selectRole } = adminAuthSlice.selectors;
export default adminAuthSlice.reducer;
